import { loadImage } from "./loadImage";
import { getImageData } from "./getImageData";
import { encode } from "blurhash";

export async function encodeImageToBlurhash(imageUrl) {
  const image = await loadImage(imageUrl);
  const imageData = getImageData(image);
  return encode(imageData.data, imageData.width, imageData.height, 4, 4);
}
